import { ButtonHeaderAddComponent } from './button-header-add.component';

export default angular
  .module('sfMobile.components.button-header-add', [
    'sfMobile.components.button-header',
  ])
  .component('sfButtonHeaderAdd', ButtonHeaderAddComponent).name;
